export default __webpack_public_path__ + "img/gorm.ff638e6e.jpg";